import { filter } from 'lodash'
import './index.scss'
// import { articlesMap, defaultArticleId, ARTICLES_LIST } from './article.js'

import { initApp, setActiveNav } from 'app/js/app'

const ARTICLE_CONFIG = require('./config')

const { articleList } = ARTICLE_CONFIG

let loadArticleList = articleList
let showArticleList = loadArticleList

let articleSearchText = ''
let articleActiveCategory = ''
let articleActiveTag = ''

function addArticleNav(needClear) {
    const articleNavDom = $('#article-nav-list')
    if (needClear) {
        articleNavDom.empty()
        showArticleList.map(item => {
            const articleNavItemDom = $(`<div class="article-nav-item" data-id="${item.id}"></div>`)
            if (item.category) {
                const categoryDom = $(`<div class="article-nav-item-category" data-category="${item.category}">${item.category}</div>`)
                articleNavItemDom.append(categoryDom)
            }
            const titleDom = $(`<a class="article-nav-item-title" title="${item.title}" href="./html/${item.id}.html">${item.title}</a>`)
            articleNavItemDom.append(titleDom)
            if (item.desc) {
                const descDom = $(`<a class="article-nav-item-abstract" href="./html/${item.id}.html">${item.desc}</a>`)
                articleNavItemDom.append(descDom)
            }
            if (item.author || item.date || (item.tags && item.tags.length)) {
                const infoDom = $('<div class="article-nav-item-info"></div>')
                if (item.author) {
                    infoDom.append($(`<span class="author mr-3">${item.author}</span>`))
                }
                if (item.date) {
                    infoDom.append($(`<span class="date mr-3">${item.date}</span>`))
                }
                if (item.tags && item.tags.length) {
                    const tagsDom = $('<span class="tags"></span>')
                    item.tags.map((tag, index) => {
                        tagsDom.append($(`<span class="article-tag" data-tag="${tag}">${tag}</span>`))
                        if (index !== item.tags.length - 1) {
                            tagsDom.append($(`<span class="ml-2 mr-2">|</span>`))
                        }
                    })
                    infoDom.append(tagsDom)
                }
                articleNavItemDom.append(infoDom)
            }
            articleNavDom.append(articleNavItemDom)
        })
    }

    // 注册事件
    $('.tags').on('click', '.article-tag', function (e) {
        const { tag = '' } = e.currentTarget.dataset
        articleActiveTag = tag
        const target = $(`.article-tags-item[data-tag="${tag}"]`)
        target.addClass('active').siblings().removeClass('active')
        filterArticle()
    })
    $('.article-nav-item-category').on('click', function (e) {
        const { category = '' } = e.currentTarget.dataset
        articleActiveCategory = category
        const target = $(`.article-tags-item[data-category="${category}"]`)
        target.addClass('active').siblings().removeClass('active')
        filterArticle()
    })
}

function initArticleCategory() {
    // const categoryListDom = $('#article-category-list')
    // const referListDom = $('#article-refer-list')
    // const tagsListDom = $('#article-tags-list')
    // const categoryList = []
    // const tagsList = []
    // articleList.map((item, index) => {
    //     // 分类
    //     if (index === 0) {
    //         const categoryItemDom = $(`<a class="article-tags-item active">全部</a>`)
    //         categoryListDom.append(categoryItemDom)
    //     }
    //     if (item.category && !categoryList.includes(item.category)) {
    //         categoryList.push(item.category)
    //         const categoryItemDom = $(`<a class="article-tags-item" data-category="${item.category}">${item.category}</a>`)
    //         categoryListDom.append(categoryItemDom)
    //     }
    //     if (item.tags && item.tags.length) {
    //         item.tags.map(tag => {
    //             const targetIdx = tagsList.findIndex(s => s.name === tag)
    //             if (targetIdx === -1) {
    //                 tagsList.push({name: tag, count: 1})
    //             } else {
    //                 tagsList[targetIdx].count += 1
    //             }
    //         })
    //     }
    //     // 推荐文章
    //     if (item.refer) {
    //         const referItemDom = $(`<a class="article-refer-item" href="./html/${item.id}.html">${item.title}</a>`)
    //         referListDom.append(referItemDom)
    //     }
    // })
    // // 标签
    // tagsList.sort((a, b) => {
    //     return b.count - a.count
    // })
    // tagsList.map((item, index) => {
    //     if (index === 0) {
    //         const tagsItemDom = $(`<a class="article-tags-item active"># 全部（${articleList.length}）</a>`)
    //         tagsListDom.append(tagsItemDom)
    //     }
    //     const tagsItemDom = $(`<a class="article-tags-item" data-tag="${item.name}"># ${item.name}（${item.count}）</a>`)
    //     tagsListDom.append(tagsItemDom)
    // })

    // 注册事件
    $('#article-search-input').on('input', function (e) {
        const value = e.currentTarget.value
        articleSearchText = value
        if (!value) {
            filterArticle()
        }
    })
    $('#article-search-input').on('keydown', function (e) {
        if (e.keyCode == '13') {
            filterArticle()
        }
    })
    $('#article-search-icon').on('click', function () {
        filterArticle()
    })
    $('#article-category-list').on('click', '.article-tags-item', function (e) {
        const { category = '' } = e.currentTarget.dataset
        articleActiveCategory = category
        $(this).addClass('active').siblings().removeClass('active')
        filterArticle()
    })
    $('#article-tags-list').on('click', '.article-tags-item', function (e) {
        const { tag = '' } = e.currentTarget.dataset
        articleActiveTag = tag
        $(this).addClass('active').siblings().removeClass('active')
        filterArticle()
    })
}

function filterArticle() {
    if (articleSearchText || articleActiveCategory || articleActiveTag) {
        const targetArticleList = articleList.filter(item => {
            let isTrue = true
            if (articleSearchText && !item.title.includes(articleSearchText) && !(item.desc || '').includes(articleSearchText)) {
                isTrue = false
            }
            if (articleActiveCategory && (!item.category || item.category !== articleActiveCategory)) {
                isTrue = false
            }
            if (articleActiveTag && (!item.tags || !item.tags.includes(articleActiveTag))) {
                isTrue = false
            }
            return isTrue
        })
        showArticleList = targetArticleList
        addArticleNav(true)
        return
    }
    showArticleList = loadArticleList
    addArticleNav(true)
}

function initArticle() {
    const articleNavDom = $('#article-nav-list')
    if (articleNavDom.length) {
        // 文章首页
        initArticleCategory()
        addArticleNav()
    } else {
        // 文章详情页面
        // 当前id
        const articleDom = $('#article-content')
        // 目录
        const catalogueDom = $('#article-catalogue-list')
        const articleInfoDoms = articleDom.children()
        articleInfoDoms.each(function () {
            const articleItem = $(this)
            if ((articleItem.attr('class') || '').includes('article-h1')) {
                catalogueDom.append($(`<a class="catalogue-item" href="#${articleItem.attr('id')}">${articleItem.text()}</a>`))
            }
            if ((articleItem.attr('class') || '').includes('article-h2')) {
                catalogueDom.append($(`<a class="catalogue-item indent-20" href="#${articleItem.attr('id')}">${articleItem.text()}</a>`))
            }
        })

        // 其它
        // const othersDom = $('#article-other-list')
        // othersDom.empty()
        // articleList.map((item, index) => {
        //     if (item.id !== currentId && index < 1000) {
        //         const othersItemDom = $(`<div class="other-article-item" data-id=${item.id}>${item.title}</div>`)
        //         othersDom.append(othersItemDom)
        //     }
        // })
    }
    
    
}

setActiveNav()
$(() => {
  initApp()
  initArticle()
    $('.other-article-list').on('click', '.other-article-item', function (e) {
        const { id } = e.currentTarget.dataset
        if (id) {
            const { origin } = window.location
            window.location.href = `${origin}/article/html/${id}.html`
        }
    })
})




// WEBPACK FOOTER //
// ./src/article/index.js